import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { apiCallAsync, apiCall } from '../apiclient';
import { Spinner, Card, Button, Form } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';

import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool, } from "@aws-sdk/credential-provider-cognito-identity";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import  ImportStatus from './ImportStatus';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

export default function CatalogImport(props) {
    const [importFile, setImportFile] =
            useState(null);
    const [catalogName, setCatalogName] =
            useState(null);
    const [someFile, setSomeFile] =
            useState(null);
    const [importStatus, setImportStatus] =
            useState(null);
    const [mqttClientCreds, setMqttClientCreds] =
            useState(null);
    const [mqttClient, setMqttClient] = 
            useState(null);
    const [mqttUUID, setMqttUUID] = 
            useState(null);
    const [buttonDisabled, setButtonDisabled] =
            useState(false);
    
    var curFile = null;

    const onDrop = useCallback(acceptedFiles => {
        setImportFile(`${acceptedFiles[0].path} (${acceptedFiles[0].size} bytes)`);
        setCatalogName(acceptedFiles[0].path.split('.')[0])
        setSomeFile(acceptedFiles[0]);
        setButtonDisabled(false);
    }, []);

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, maxFiles: 1})

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ])

    useEffect(() => {

        return( () => {
            if (mqttClient !== null) {
            // console.log(`ImportStatus() disconnecting from ${mqttClientCreds.host}`);
            mqttClient.end();
            }
        });
    }, [mqttClient])

    async function uploadToBucket(f, cred) {
        
        try {
            
            const s3 = new S3Client({
                region: cred.region,
                credentials: fromCognitoIdentityPool({
                    client: new CognitoIdentityClient({ region: cred.region}),
                    identityPoolId: cred.identity_pool_id,
                    logins: cred.logins
                })
            })

            var s3_key = encodeURIComponent(f.name);
            const uploadParams = {
                Bucket: cred.s3_bucket,
                Key: s3_key,
                Body: f,
            };
            const data = await s3.send(new PutObjectCommand(uploadParams));
        } catch (upload_ex) {
            console.log(upload_ex);
            throw(upload_ex);
        }
    }

    async function runImport(keyName, cred) {
        let requestPayload = {
                    userUUID: cred.uuid,
                    bucket: cred.s3_bucket,
                    objectKey: encodeURIComponent(keyName),
                    catalogName: catalogName
            }
        let invokeParms = {
            FunctionName: 'dance-dj-catalog-import',
            InvocationType: 'Event',
            Payload: JSON.stringify(requestPayload)
        }
        const lambdaClient = new LambdaClient({
            region: cred.region,
            credentials: fromCognitoIdentityPool({
                client: new CognitoIdentityClient({ region: cred.region}),
                identityPoolId: cred.identity_pool_id,
                logins: cred.logins
            })
        });
        try {
            const cmd = new InvokeCommand(invokeParms);
            let result = await lambdaClient.send(cmd);
        } catch (exc) {
            console.log(lambdaClient);
            console.log(exc);
            console.log(JSON.stringify(invokeParms));
        }
    }

    async function startImport() {
        try {
            setButtonDisabled(true);
            let cred = await apiCallAsync('get', '/credentials');
            setMqttClientCreds(cred.mqtt_client);
            setMqttUUID(cred.uuid);
            setImportStatus({variant: 'info', message: 'Uploading...'})
            await uploadToBucket(someFile, cred);
            await runImport(someFile.name, cred);

        } catch(e) {
            console.log(e);
        }
        
    }

    return(
        <div class="mx-auto w-50">
        <p></p>
        <Card>
        <Card.Title className="mx-auto">Import Data for Catalogs</Card.Title>
        <Card.Body>
        <section className="container" >
        <div {...getRootProps({style})}>
        <input {...getInputProps()} />
            { isDragActive ?
              <p>Drop the file here ...</p> :
              <p>Drag and drop a file here, or click to select a file</p>  
        }
        </div>
        {(importFile !== null) &&
            <div>
                <center>
                    {importFile}
                </center>
                <p></p>
                <Form>
                    <Form.Group className="mb-3" controlID="catalogName">
                        <Form.Label>Catalog Name</Form.Label>
                        <Form.Control type="text" value={catalogName}
                            onChange={(evt) => setCatalogName(evt.currentTarget.value)}
                        />
                    </Form.Group>
                </Form>
                <center>
                    <Button className="mx-auto mb-3" variant="primary"
                    disabled={buttonDisabled}
                    onClick={() => startImport()}>Upload &amp; Import</Button>
                </center>
                { (importStatus != null) &&
                <ImportStatus mqttClientCreds={mqttClientCreds} uuid={mqttUUID}
                    client={mqttClient} setClient={setMqttClient}
                    initialStatus={importStatus} />
                }
            </div>

        }
        </section>
        </Card.Body>
        </Card>
        </div>
    )
}